import React from 'react';
import '../App.css';

const DiscoverNewAlert = ({ isOpen, onClose, onBack, onProceed }) => {
  if (!isOpen) return null;

  return (
    <div className="jam-modal-overlay" onClick={onClose}>
      <div className="jam-modal-content discover-alert-modal" onClick={(e) => e.stopPropagation()}>
        <div className="jam-modal-header">
          <h2>🔍 Find Tracks in Discovery Zone</h2>
          <button className="jam-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="jam-modal-body">
          <div className="discover-alert-content">
            <p className="discover-alert-title">To start your jam session:</p>
            
            <div className="discover-steps">
              <div className="discover-step">
                <span className="step-number">1️⃣</span>
                <span>We'll take you to Discovery Zone</span>
              </div>
              <div className="discover-step">
                <span className="step-number">2️⃣</span>
                <span>Search tracks</span>
              </div>
              <div className="discover-step">
                <span className="step-number">3️⃣</span>
                <span>Click 🎵 on desired track</span>
              </div>
              <div className="discover-step">
                <span className="step-number">4️⃣</span>
                <span>Your session will begin</span>
              </div>
            </div>
          </div>
        </div>

        <div className="jam-modal-footer" style={{ justifyContent: 'space-between' }}>
          {onBack && (
            <button 
              className="jam-btn jam-btn-secondary" 
              onClick={onBack}
              style={{ padding: '0.4rem 0.8rem', fontSize: '0.85rem' }}
            >
              ← Back
            </button>
          )}
          <button 
            className="jam-btn jam-btn-primary" 
            onClick={onProceed}
            style={{ padding: '0.4rem 0.8rem', fontSize: '0.85rem' }}
          >
            Take Me to Discovery Zone
          </button>
          <button 
            className="jam-btn jam-btn-secondary" 
            onClick={onClose}
            style={{ padding: '0.4rem 0.8rem', fontSize: '0.85rem' }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscoverNewAlert;
